import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full whitespace-nowrap">
            读者评价
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mt-3">
            读者们怎么说
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            来自真实读者的评价与反馈
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="break-inside-avoid mb-5 bg-background-100 rounded-lg p-5 border border-background-200/50"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-400 whitespace-nowrap">
                    {t.username}
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                &ldquo;{t.content}&rdquo;
              </p>
              <div className="flex items-center gap-0.5 mt-3">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i
                    key={i}
                    className="ri-star-fill text-xs text-primary-400"
                  ></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}